var Filter     = Filter || {};
Filter.options = Filter.options || {};
Filter.default = {

  filterDataId: '#js-filter-data',

  priceSliderId:    '.js-price-slider-range',
  pricePoolLeftId:  '.price-pool .left',
  pricePoolRightId: '.price-pool .right',

  parameterFormId: '#filter-parameter-form'

  //step: 10,
  //priceSliderMin: 0,
  //priceSliderMax: 15000,
  //actualPriceSliderMin: Filter.options.priceSliderMin,
  //actualPriceSliderMax: Filter.options.priceSliderMax,
  //currencySign: 'Kč'

};
Filter.options = $.extend(Filter.default, Filter.options);
Filter.fire    = false;

$(function () {

  var productHolder = $('[data-product-holder]');
  var filterHolder = $('.product-list-filter-big');

  //pouziti range slider
  Filter.initParameterSwitcher(productHolder, filterHolder);

  Filter.priceSliderInit(productHolder, filterHolder);

  $(document)
    .on('change', Filter.options.parameterFormId + ' input[type="radio"]',
        function () {
          Filter.fire = true;
          loaderActive(productHolder);
          loaderActive(filterHolder);
          $(Filter.options.parameterFormId).submit();
        });

  $(document).on('click', '.js-ajax-url', function (e) {
    e.preventDefault();
    Filter.fire = true;
    loaderActive(productHolder);
    loaderActive(filterHolder);
    $.nette.ajax($(this).attr('href'));
  });

  $.nette.ext('filterSuccess', {
    success: function (payload) {
      if (Filter.fire) {

        //console.log(Filter.getFilterLink());

        // inicializace price range slideru po ajaxu
        Filter.priceSliderInit(productHolder, filterHolder);

        // inicializace range slideru po ajaxu
        Filter.rangeSliderInit(productHolder, filterHolder);
        Filter.rangSliderSingleInit(productHolder, filterHolder);

        window.history.pushState({}, '', Filter.getFilterLink());

        loaderClose(productHolder);
        loaderClose(filterHolder);

        Filter.initParameterSwitcher(productHolder, filterHolder);
      }
    }
  });

  $(window).on('popstate', function (event) {
    if (Filter.fire) {
      $.nette.ajax(window.location.href);
      Filter.fire = false;
    }
  });

  // odeslani formulare
  $('body').on('change', '.js-submit-form', function () {
    Filter.fire = true;
    loaderActive(productHolder);
    loaderActive(filterHolder);
    $(this).closest('form').submit();
  });

  // inicializace vsech range slideru ve filtru
  Filter.rangeSliderInit(productHolder, filterHolder);
  Filter.rangSliderSingleInit(productHolder, filterHolder);

});

/**
 * @return void
 */
Filter.priceSliderInit = function (productHolder, filterHolder) {

  var $range = $(Filter.options.priceSliderId);

  if (!$range.length) {
    return;
  }

  var $container = $range.parent(),

      // mena
      $currency  = $range.data('currency'),

  // inputy s min a max hodnotou
    $fromValue = $('.js-price-slider-selected-min', $container),
    $toValue = $('.js-price-slider-selected-max', $container),

    // min a max hodnoty slideru
    $min = $range.data('min'),
    $max = $range.data('max'),

    // vybrana min a max hodnota
    $selectedMin = $fromValue.val() ? $fromValue.val() : $min,
    $selectedMax = $toValue.val() ? $toValue.val() : $max;

  var $form = $range.closest('form');

  var updateValues = function () {
    $('.js-price-slider-selected-min', $container).val($selectedMin);
    $('.js-price-slider-selected-max', $container).val($selectedMax);
  };

  $range.ionRangeSlider({
                          type: 'double',
                          min:  $min,
                          max:  $max,

                          from: $selectedMin,
                          to:   $selectedMax,

                          grid:         false,
                          force_edges:  true,
                          postfix:      ' ' + $currency,
                          hide_min_max: true,
                          // hide_from_to: true,
                          onChange:     function (data) {

                            $selectedMin = data.from;
                            $selectedMax = data.to;

                            updateValues();

                            //value = data.from;
                          },
                          onFinish:     function (data) {
                            Filter.fire = true;

                            console.log(productHolder);

                            loaderActive(productHolder);
                            loaderActive(filterHolder);

                            $form.submit();
                          }

                        });

};

Filter.rangSliderSingleInit = function (productHolder, filterHolder){

  var $rangeSingleList = $('.js-my-range-slider-single');

  if (!$rangeSingleList.length) {
    return;
  }

  // pro kazdy range slider
  $rangeSingleList.each(function ($i, $rangeEl) {
    var $range = $(this);
    var $form = $range.closest('form');
    var $dataMin   = $range.data('range-min');
    var $dataMax   = $range.data('range-max');
    var $fromValue   = $range.data('range-from');
    var $valuesString   = $range.data('range-values');
    var $values   = $valuesString.split(",");
    // console.log($values);

    var $options = {

      from: $fromValue,
      values: $values,
      min: $dataMin,
      max: $dataMax,
      grid:         false,
      force_edges:  true,
      hide_min_max: false,
      // hide_from_to: true,
      onChange:     function (data) {
        var value = data.from_value == 0? null : data.from_value;
        $range.val(value);
      },
      onFinish:     function (data) {
        var value = data.from_value == 0? null : data.from_value;
        $range.val(value);
        Filter.fire = true;

        loaderActive(productHolder);
        loaderActive(filterHolder);

        $form.submit();
      }

    };

    // inicializace range slideru
    $range.ionRangeSlider($options);
  });
}

/**
 * Inicializace obecneho range slideru
 * @return void
 */
Filter.rangeSliderInit = function (productHolder, filterHolder) {

  var $rangeList = $('.js-my-range-slider');

  if (!$rangeList.length) {
    return;
  }

  // pro kazdy range slider
  $rangeList.each(function ($i, $rangeEl) {

    var $range     = $(this),

        $container = $range.parent(),

        // postfix
        $postfix   = $range.data('postfix'),

      // inputy s min a max hodnotou
      $fromValue = $('.js-slider-range-selected-min', $container),
      $toValue = $('.js-slider-range-selected-max', $container),

      // min a max hodnoty slideru
      $min = $range.data('min'),
      $max = $range.data('max'),

      // vybrana min a max hodnota
      $selectedMin = $fromValue.val() ? $fromValue.val() : $min,
      $selectedMax = $toValue.val() ? $toValue.val() : $max;

    var $form = $range.closest('form');

    var updateValues = function () {

      // tento zapis nefunguje, nemeni hodnoty po ajaxu
      //$fromValue.val($selectedMin);
      //$toValue.val($selectedMax);

      $('.js-slider-range-selected-min', $container).val($selectedMin);
      $('.js-slider-range-selected-max', $container).val($selectedMax);

    };

    var $options = {
      type: 'double',
      min:  $min,
      max:  $max,

      from: $selectedMin,
      to:   $selectedMax,

      grid:         false,
      force_edges:  true,
      hide_min_max: true,
      // hide_from_to: true,
      onChange:     function (data) {

        $selectedMin = data.from;
        $selectedMax = data.to;

        updateValues();

      },
      onFinish:     function (data) {
        Filter.fire = true;

        loaderActive(productHolder);
        loaderActive(filterHolder);

        $form.submit();
      }

    };

    if ($postfix) {
      $options.postfix = ' ' + $postfix;
    }

    // inicializace range slideru
    $range.ionRangeSlider($options);

  });

};

/**
 *
 * @returns string
 */
Filter.getFilterLink = function () {
  return $(Filter.options.filterDataId).data('link');
};

Filter.initParameterSwitcher = function (productHolder, filterHolder) {
  var $usageSlider = $('.js-usage-slider-range');
  /*
  var options = {
    onFinish: function (data) {
      Filter.fire = true;
      loaderActive(productHolder);

      $.nette.ajax({
                     url:  data.input.data('link'),
                     data: {
                       'parameterSwitcher-sliderValue': data.from
                     }
                   });
    }
  };
  */
  $usageSlider.ionRangeSlider();

  $usageSlider.on('change', function(){
    var $this = $(this);
    var $link = $this.data('link');
    var $from = $this.data("from");

    console.log($link);
    console.log($from);

    Filter.fire = true;
    loaderActive(productHolder);
    loaderActive(filterHolder);
    $.nette.ajax({
      url:  $link,
      data: {
        'parameterSwitcher-sliderValue': $from
      }
    });
  });

  var $usageSliderData = $usageSlider.data("ionRangeSlider");
  $('.js-usage-irs-right').on('click', function () {
    $usageSliderData.update({
      from: 2
    });
  });
  $('.js-usage-irs-left').on('click', function () {
    $usageSliderData.update({
      from: 0
    });
  });
};

function loaderActive (productHolder) {
  if (productHolder.find('.processed').length) {
    return;
  }
  productHolder.append('<div class="processed"><div class="spinner">\n' +
                         '  <div class="bounce1"></div>\n' +
                         '  <div class="bounce2"></div>\n' +
                         '  <div class="bounce3"></div>\n' +
                         '</div></div>');
  productHolder.css({
                      'opacity': '0.7'
                    });
};

function loaderClose (productHolder) {
  if (productHolder) {
    console.log('close');
    productHolder.find('.processed').remove();
    productHolder.css({
                        'opacity': '1'
                      });
  }
}